module.exports = __webpack_public_path__ + "img/grid-picture-1x1.aa5dbdae.jpg";